// Copyright (c) 2018 Comsearch, Inc., All rights reserved

const getProjectTypeOptions = () => (dispatch, getState) => {
  const { user } = getState()

  const options = []

  // if the user has engineering permissions, allow them to create
  // In Progress and (PCN) Renewal Projects
  if (user.getIn(['permissions', 'engineering'])) {
    options.push({
      label: 'Engineering',
      value: '1',
    })
  }

  // if the user has db permissions, allow them to create External PCN projects
  if (user.getIn(['permissions', 'database'])) {
    options.push({
      label: 'External PCN',
      value: '2',
    })
  }

  // engineering users can also create protection projects
  if (user.getIn(['permissions', 'engineering'])) {
    options.push({
      label: 'Protection',
      value: '3',
    })
  }

  return options
}

export default getProjectTypeOptions
